import { ApttusDirectDebitStatus } from '@/interfaces/entities/apttus-direct-debit-status-response.interface';

const paymentConnectedDirectDebit = (directDebitStatus: ApttusDirectDebitStatus): boolean => {
  return directDebitStatus === ApttusDirectDebitStatus.Current;
};

const paymentNotSetupDirectDebit = (directDebitStatus: ApttusDirectDebitStatus): boolean => {
  return directDebitStatus == ApttusDirectDebitStatus.NotFound;
};

export const RSADirectDebitDisplayRules = {
  paymentConnectedDirectDebit,
  paymentNotSetupDirectDebit,
};
